export default __webpack_public_path__ + "static/media/blue_clock.807c48a5.svg";